import { CopyIcon } from 'Assets/index';
import styles from './TitleWithIcon.module.scss';

interface TitleWithIconProps {
  content: string;
  icon: typeof CopyIcon;
  iconTitle: string;
  iconClickHandler: () => void;
  iconVisibility?: boolean;
  customStyles?: string;
}

export const TitleWithIcon: React.FC<TitleWithIconProps> = ({
  content,
  icon: Icon,
  iconClickHandler,
  iconTitle = '',
  iconVisibility = true,
  customStyles = '',
}) => {
  return (
    <div className={styles.titleWithIcon}>
      <h5 className={styles.titleWithIcon__content}>{content}</h5>
      {iconVisibility && (
        <Icon
          className={`${styles.titleWithIcon__icon} ${customStyles}`}
          onClick={iconClickHandler}
          title={iconTitle}
        />
      )}
    </div>
  );
};
